package com.sddamico.swigmore.ds.poll

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.FieldRowStyle
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.forms.IconButton
import com.sddamico.swigmore.ds.forms.IconButtonVariant
import com.sddamico.swigmore.ds.typeBody
import com.sddamico.swigmore.ds.typeMono
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** An unranked team in "The Field": name, record · last week, and a gold + to add it to the ballot. */
@Composable
fun FieldTeamRow(
  team: String,
  record: String,
  lastWeek: String?,
  modifier: Modifier = Modifier,
  onAdd: (() -> Unit)? = null,
  onDragStart: (() -> Unit)? = null,
  onDragEnd: (() -> Unit)? = null,
) {
  val dragStart = onDragStart
  val dragEnd = onDragEnd
  Div(
    attrs = FieldRowStyle.toModifier()
      .css("display" to "grid", "grid-template-columns" to "minmax(0,1fr) auto 26px", "gap" to "10px",
        "align-items" to "center", "padding" to "8px 10px", "border-radius" to "7px",
        "cursor" to if (dragStart != null) "grab" else "pointer")
      .then(modifier)
      .toAttrs {
        if (dragStart != null) {
          attr("draggable", "true")
          onDragStart { ev -> ev.dataTransfer?.setData("text/plain", team); dragStart() }
          onDragEnd { dragEnd?.invoke() }
        }
        if (onAdd != null) onClick { onAdd() }
      }
  ) {
    Span(attrs = Modifier.typeBody("14px", 600, "normal").toAttrs()) { Text(team) }
    Span(attrs = Modifier.typeMono("11px").css("color" to SwColor.textMuted).toAttrs()) { Text(listOfNotNull(record, lastWeek).joinToString(" · ")) }
    IconButton("+", "Add $team", variant = IconButtonVariant.Add, onClick = onAdd)
  }
}
